import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Loader2, ChevronLeft, Package, GraduationCap, Trash2, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { useFavoritos } from "../context/FavoritosContext";
import { toast } from "sonner";

const TIPO = { producto: { Icon: Package, color: "#D97706", label: "Producto" }, curso: { Icon: GraduationCap, color: "#7E22CE", label: "Curso" } };

export default function FavoritosPage() {
  const [data, setData] = useState(undefined);
  const { toggle, refresh } = useFavoritos();

  const cargar = () => api.get("/favoritos").then(({ data }) => setData(data)).catch(() => setData(null));
  useEffect(() => { cargar(); }, []);

  const quitar = async (it) => {
    await toggle({ tipo: it.tipo, ref_id: it.ref_id, titulo: it.titulo, subtitulo: it.subtitulo, enlace: it.enlace, imagen: it.imagen });
    await cargar();
    await refresh();
  };

  return (
    <div className="px-5 md:px-8 py-8 max-w-4xl" data-testid="favoritos-page">
      <Link to="/" className="inline-flex items-center gap-1 text-sm font-semibold text-slate-500 hover:text-slate-800"><ChevronLeft size={16} /> Volver al Ecosistema</Link>
      <h1 className="mt-4 text-3xl md:text-4xl font-extrabold text-slate-900 tracking-tight inline-flex items-center gap-3"><Heart size={30} className="fill-red-500 text-red-500" /> Favoritos</h1>
      <p className="mt-2 text-slate-600">Productos y cursos que guardaste del Marketplace.</p>

      <div className="mt-6 space-y-2">
        {data === undefined && <div className="flex items-center gap-2 text-slate-500 py-16"><Loader2 className="animate-spin" size={16} /> Cargando favoritos…</div>}
        {data === null && <p className="text-sm text-slate-400 py-10">No se pudieron cargar tus favoritos.</p>}
        {data && data.items.length === 0 && (
          <div className="text-center py-16 bg-white rounded-2xl border border-slate-100" data-testid="favoritos-vacio">
            <Heart size={40} className="mx-auto text-slate-300" />
            <p className="mt-3 text-slate-500">Aún no tienes favoritos. Guarda productos o cursos desde el Marketplace.</p>
            <Link to="/tienda" className="mt-4 inline-block font-bold text-red-500">Explorar Marketplace</Link>
          </div>
        )}
        {data?.items.map((it) => {
          const m = TIPO[it.tipo] || TIPO.producto; const Icon = m.Icon;
          return (
            <div key={it.id} className="flex items-center gap-3 p-3 rounded-2xl border border-slate-100 bg-white" data-testid={`favorito-${it.ref_id}`}>
              <div className="w-14 h-14 rounded-xl overflow-hidden bg-slate-100 flex items-center justify-center flex-shrink-0">
                {it.imagen ? <img src={it.imagen} alt={it.titulo} className="w-full h-full object-cover" /> : <Icon size={20} style={{ color: m.color }} />}
              </div>
              <Link to={it.enlace || "/tienda"} className="min-w-0 flex-1">
                <p className="font-bold text-slate-900 text-sm truncate hover:underline">{it.titulo}</p>
                <p className="text-xs text-slate-500">{m.label}{it.subtitulo ? ` · ${it.subtitulo}` : ""}</p>
              </Link>
              <Link to={it.enlace || "/tienda"} className="p-2 text-slate-300 hover:text-slate-600"><ArrowRight size={16} /></Link>
              <button onClick={() => quitar(it)} data-testid={`favorito-quitar-${it.ref_id}`} className="p-2 rounded-lg text-red-500 hover:bg-red-50"><Trash2 size={15} /></button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
